//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
import contractTp from '@/components/page-temporary/contractTp'
import contractTodoTp from '@/components/page-temporary/contractTodoTp'
import {appBaseUrl} from '@/utils/commons'
export default {
  name: "contract-detail-query",
  components: {
    divSpan,
    contractTp,
    contractTodoTp
  },
  data() {
    return {
      show: true,
      mt:"",
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '合同明细查询',
        url: 'api/contract-mat/page',
        workflowSearchBean: {},
        fixRules: {
          rules: [{
            field: "contractBase.deleted",
            option: "EQ",
            values: ["0"]
          }]
        },
        inputCondition: {
          placeholder: '合同编号/名称/供应商',
          searchCondition: 'key',
          rules: [{
            field: "contractName-contractCode-supplier.supplierName-supplier.supplierCode",
            option: "LIKE_ANYWHERE"
          }]
        },
        selectConfig: [
          // {
          //   text: '合同状态',
          //   type: 'selector',
          //   list: [{name:'全部',code:null},{name:'审批中',code: 'check'},{name:'已发布',code: 'end'}, {name: '已作废', code: 'delete'}],
          //   rules: [{field: "contractBase.status", option: "EQ"}],
          // },
          {
            text:'合同类型',
            type:'selector',
            list:[{name:'全部',code:null}],
            rules:[{field:"contractBase.contractType",option:"IN"}]
          },
          {
            text:'合同属性',
            type:'selector',
            list:[{name:'全部',code:null}],
            rules:[{field:"contractBase.contractAttribute",option:"IN"}]
          }
        ]
      },
      searchData: {},
      list: []
    }
  },
  methods: {
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    initSelect(){
      this.$get('api/dict-tables/search-with-list?dictCode=contractType').then((res) => {
        if(res){
          res.dictItems.forEach((item) => {
            this.config.selectConfig[1].list.push({
              name:item.value,
              code:item.code
            })
          })
        }
      });
      this.$get('api/dict-tables/search-with-list?dictCode=contractAttribute').then((res) => {
        if(res){
          res.dictItems.forEach((item) => {
            this.config.selectConfig[2].list.push({
              name:item.value,
              code:item.code
            })
          })
        }
      })
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    },
    goDetail(data){
      this.$router.push(`/contract/${data.contractId}/${'query'}`);
    }
  },
  mounted() {
    this.init();
    this.initSelect();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/contract/contract-detail-query.vue